import approvals from "./approvals/manifest";
import communication from "./communication/manifest";
import companies from "./companies/manifest";
import contracts from "./contracts/manifest";
import delegation from "./delegation/manifest";
import financialClaims from "./financial-claims/manifest";
import importingEntities from "./importing-entities/manifest";
import incomingOffersPriceAnalysis from "./incoming-offers-price-analysis/manifest";
import negotiationAward from "./negotiation-award/manifest";
import offers from "./offers/manifest";
import notifications from "./notifications/manifest";
import platformGuide from "./platform-guide/manifest";
import preferredVendors from "./preferred-vendors/manifest";
import proposalApprovals from "./proposal-approvals/manifest";
import subscriptions from "./subscriptions/manifest";
import tenders from "./tenders/manifest";
import tenderViewing from "./tender-viewing/manifest";
import workClassification from "./work-classification/manifest";

export const MODULE_MANIFESTS = [
  tenders,
  offers,
  tenderViewing,
  negotiationAward,
  financialClaims,
  importingEntities,
  incomingOffersPriceAnalysis,
  subscriptions,
  preferredVendors,
  approvals,
  proposalApprovals,
  delegation,
  companies,
  workClassification,
  communication,
  notifications,
  contracts,
  platformGuide,
].filter(Boolean);

export const getModuleManifestByKey = (key) =>
  MODULE_MANIFESTS.find((m) => m.key === key) || null;

export const buildServiceModulesFromManifests = () =>
  MODULE_MANIFESTS.filter((m) => m.isServiceModule !== false).map((m) => ({
    key: m.key,
    planNameEn: m.names?.plan?.en || "",
    planNameAr: m.names?.plan?.ar || "",
    planNameZhHans: m.names?.plan?.["zh-Hans"] || "",
    dashboardNameEn: m.names?.dashboard?.en || "",
    dashboardNameAr: m.names?.dashboard?.ar || "",
    dashboardNameZhHans: m.names?.dashboard?.["zh-Hans"] || "",
    defaultPath: m.defaultPath || "/dashboard",
    matchers: Array.isArray(m.matchers) ? m.matchers : [],
    hidden: m.hidden === true,
  }));

export const buildNavbarMenusByKeyFromManifests = ({
  t,
  activeModuleLabel,
  ALL_TENDERS_ENABLED,
  COMPANY_LIST_ENABLED,
  isAuthorizedOnly,
  user,
}) => {
  const out = {};
  for (const m of MODULE_MANIFESTS) {
    if (typeof m.buildNavbarMenus !== "function") continue;
    out[m.key] = m.buildNavbarMenus({
      t,
      activeModuleLabel,
      ALL_TENDERS_ENABLED,
      COMPANY_LIST_ENABLED,
      isAuthorizedOnly,
      user,
    });
  }
  return out;
};
